// extracted by mini-css-extract-plugin
module.exports = {"header":"header__JKdWy","title":"title__2KAX2"};